// extracted by mini-css-extract-plugin
module.exports = {"container":"Versions_container__1b7UD"};